// 都道府県コードマッピング（一部・主要エリア例）
export interface RegionShippingFee {
  regionName: string
  prefectures: string[]
  rates: { maxWeightKg: number; fee: number }[]
}

export const REGION_SHIPPING_FEES: RegionShippingFee[] = [
  {
    regionName: '北海道',
    prefectures: ['北海道'],
    rates: [
      { maxWeightKg: 3, fee: 1200 },
      { maxWeightKg: 5, fee: 1400 },
      { maxWeightKg: 10, fee: 1800 },
      { maxWeightKg: 20, fee: 2300 },
    ],
  },
  {
    regionName: '東北',
    prefectures: ['青森県', '岩手県', '秋田県', '宮城県', '山形県', '福島県'],
    rates: [
      { maxWeightKg: 3, fee: 900 },
      { maxWeightKg: 5, fee: 1100 },
      { maxWeightKg: 10, fee: 1400 },
      { maxWeightKg: 20, fee: 1900 },
    ],
  },
  {
    regionName: '関東・甲信越',
    prefectures: ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県', '群馬県', '山梨県', '長野県', '新潟県'],
    rates: [
      { maxWeightKg: 3, fee: 800 },
      { maxWeightKg: 5, fee: 980 },
      { maxWeightKg: 10, fee: 1280 },
      { maxWeightKg: 20, fee: 1780 },
    ],
  },
  {
    regionName: '中部・北陸',
    prefectures: ['愛知県', '岐阜県', '静岡県', '三重県', '富山県', '石川県', '福井県'],
    rates: [
      { maxWeightKg: 3, fee: 850 },
      { maxWeightKg: 5, fee: 1050 },
      { maxWeightKg: 10, fee: 1350 },
      { maxWeightKg: 20, fee: 1850 },
    ],
  },
  {
    regionName: '関西',
    prefectures: ['大阪府', '兵庫県', '京都府', '滋賀県', '奈良県', '和歌山県'],
    rates: [
      { maxWeightKg: 3, fee: 900 },
      { maxWeightKg: 5, fee: 1100 },
      { maxWeightKg: 10, fee: 1400 },
      { maxWeightKg: 20, fee: 1900 },
    ],
  },
  {
    regionName: '中国・四国',
    prefectures: ['鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県'],
    rates: [
      { maxWeightKg: 3, fee: 1000 },
      { maxWeightKg: 5, fee: 1200 },
      { maxWeightKg: 10, fee: 1550 },
      { maxWeightKg: 20, fee: 2050 },
    ],
  },
  {
    regionName: '九州',
    prefectures: ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県'],
    rates: [
      { maxWeightKg: 3, fee: 1200 },
      { maxWeightKg: 5, fee: 1400 },
      { maxWeightKg: 10, fee: 1800 },
      { maxWeightKg: 20, fee: 2300 },
    ],
  },
  {
    regionName: '沖縄',
    prefectures: ['沖縄県'],
    rates: [
      { maxWeightKg: 3, fee: 1500 },
      { maxWeightKg: 5, fee: 1800 },
      { maxWeightKg: 10, fee: 2400 },
      { maxWeightKg: 20, fee: 3100 },
    ],
  },
]

/**
 * お届け先都道府県と荷物重量(kg)から送料を算出
 */
export function calculateShippingFee(prefectureName: string, weightKg: number): number {
  if (!prefectureName) return 800 // デフォルト関東料金

  const region = REGION_SHIPPING_FEES.find((r) =>
    r.prefectures.some((p) => prefectureName.includes(p) || p.includes(prefectureName))
  )

  if (!region) return 1000 // 未定義地域の場合

  const rate = region.rates.find((r) => weightKg <= r.maxWeightKg)
  if (rate) return rate.fee

  // 20kg超の場合
  const maxRate = region.rates[region.rates.length - 1]
  return maxRate.fee + Math.ceil((weightKg - 20) / 5) * 500
}

/**
 * 商品名から想定重量(kg)を推定抽出（例: 「桃 5kg」 -> 5）
 */
export function extractProductWeightKg(productName: string): number {
  const match = productName.match(/(\d+(?:\.\d+)?)\s*kg/i)
  if (match) {
    return parseFloat(match[1])
  }
  return 5 // デフォルト5kgと仮定
}
